export default "__VITE_ASSET__CCSYdM0N__"